import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultErrorLayout from '../../components/layout/DefaultErrorLayout';

export default [
  <Route key="notfound" element={<DefaultErrorLayout />}>
    {/* literal "notfound" outranks :lang, preventing a /notfound <-> :lang redirect loop */}
    <Route path="notfound" element={<AsyncPage />} />
    <Route path="*" element={<AsyncPage />} />
  </Route>,
];
